import { login_en as loginEn, login_ko as loginKo } from './login';
import { tenureCheck_en as tenureCheckEn, tenureCheck_ko as tenureCheckKo } from './tenure-check';
import { proxy_en as proxyEn, proxy_ko as proxyKo } from './proxy';
import { addResources, registerNamespace } from '@ciam/i18n';

// 각 네임스페이스 등록
const loginNs = registerNamespace('login');
const proxyNs = registerNamespace('proxy');
const tenureCheckNs = registerNamespace('tenure-check');

// 네임스페이스별로 리소스 구성
const authResources = {
  en: {
    [loginNs]: loginEn,
    [proxyNs]: proxyEn,
    [tenureCheckNs]: tenureCheckEn,
  },
  ko: {
    [loginNs]: loginKo,
    [proxyNs]: proxyKo,
    [tenureCheckNs]: tenureCheckKo,
  },
};

// 앱 초기화 시 리소스 추가
addResources(authResources);
